var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"homePop",on:{"click":function($event){_vm.show=false}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pxindBox"},[_c('img',{staticClass:"pxind",attrs:{"src":require("@/assets/img/arkHome/wx-share.png")}})])
}]

export { render, staticRenderFns }